export { useConsent, useHasConsent } from "./hooks";
export {
	acceptAll,
	clearConsent,
	readConsent,
	rejectAll,
	writeConsent,
} from "./storage";
export {
	ALL_GRANTED,
	CONSENT_COOKIE_NAME,
	CONSENT_EVENT,
	CONSENT_STORAGE_KEY,
	CONSENT_VERSION,
	type ConsentCategory,
	type ConsentChoices,
	type ConsentRecord,
	ONLY_NECESSARY,
} from "./types";

export const CONSENT_OPEN_EVENT = "ld:open-cookie-preferences";

export function openCookiePreferences(): void {
	if (typeof window === "undefined") return;
	try {
		window.dispatchEvent(new CustomEvent(CONSENT_OPEN_EVENT));
	} catch {
		// ignore
	}
}
